import { Injectable } from '@angular/core';
import { ProdDetcif } from "../prodinterfaces/proddetcif";
import { ProdEnccif } from "../prodinterfaces/prodenccif";

import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';
import { NuevoComponentService } from 'src/app/servicios/nuevo-component.service';

@Injectable({
  providedIn: 'root'
})
export class ProdcosindfaseService {

  public way: string;

  public enccif: ProdEnccif[] = [];
  //public detregcomp: Cxcdetregcomp[][] = [];
  public decimalesCostoind:number=2
  public _detcif: ProdDetcif[];
  get detcif(): ProdDetcif[] {
    return this._detcif;
  }

  set detcif(value: ProdDetcif[]) {
    this._detcif = value;
  }

  constructor(
    private http: HttpClient, public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario, private confIniciales: ConfInicialesService,
    private message: MessageService, private utilitariosService: UtilitariosService,
    private init: NuevoComponentService,
  ) {
    this.way = sessionStorage.getItem('way');
  }

  guardarenccif(item) {
    return this.http.post<any[]>(this.way + '/produccion/prodcosindtra/257e3b7d56dd760000', {
      elementos: {
        p_ENCCIF_COMPROBANTE: item.ENCCIF_COMPROBANTE,
        p_COM_CODIGO: item.COM_CODIGO,
        p_ENCCIF_FECHAEMISION: item.ENCCIF_FECHAEMISION,
        p_ENCORDPRO_NUMERO: item.ENCORDPRO_NUMERO,
        p_CENTRA_CODIGO: item.CENTRA_CODIGO,
        p_ENCCIF_COMENTARIO: item.ENCCIF_COMENTARIO,
        P_USUIDENTIFICACION: this.usuario.identificacion,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarregistrodet(areglodet) {

    return this.http.post<any[]>(this.way + '/produccion/prodcosindtra/257e3b7d56daee0000', {
      elementos: {
        areglodet
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizaenccif(item) {
    return this.http.post<any[]>(this.way + '/produccion/prodcosindtra/a677caac9d763000', {
      elementos: {
        p_ENCCIF_COMPROBANTE: item.ENCCIF_COMPROBANTE,
        p_COM_CODIGO: item.COM_CODIGO,
        p_ENCCIF_FECHAEMISION: item.ENCCIF_FECHAEMISION,
        p_ENCORDPRO_NUMERO: item.ENCORDPRO_NUMERO,
        p_CENTRA_CODIGO: item.CENTRA_CODIGO,
        p_ENCCIF_COMENTARIO: item.ENCCIF_COMENTARIO,
        P_USUIDENTIFICACION: this.usuario.identificacion,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizaregistrodet(areglodet) {

    return this.http.post<any[]>(this.way + '/produccion/prodcosindtra/a677caac9aeeb000', {
      elementos: {
        areglodet
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultaenccif(codigo) {
    return this.http.post<any[]>(this.way + '/produccion/prodcosindtra/198bf3d5ea9d760000', {
      elementos: {
        p_ENCCIF_COMPROBANTE: codigo,
        p_COM_CODIGO: '01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultadetcif(codigo) {
    return this.http.post<any[]>(this.way + '/produccion/prodcosindtra/198bf3d5ea9aef0000', {
      elementos: {
        p_ENCCIF_COMPROBANTE: codigo,
        p_COM_CODIGO: '01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  seleccionarRegistro(tipo, numero): Observable<any> {
    return this.http.post<any>(this.way + '/produccion/prodcosindtra/1c755cc64b175700000000', {
      elementos: {
        p_ENCCIF_COMPROBANTE: numero,
        p_com_codigo: '01',
        p_tipo: tipo,

      }
    }, this.confIniciales.httpOptions());
  }
  getestadoordpro(codigo) {
    return this.http.post<any[]>(this.way + '/produccion/prodcosindtra/83baee754dc3b00000000000000000', {
      elementos: {
        p_ENCORDPRO_NUMERO: codigo,
        p_COM_CODIGO: '01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  borrarRegistro(codigo) {
    return this.http.post<any[]>(this.way + '/produccion/prodcosindtra/1d595a5756dd760000', {
      elementos: {
        p_ENCCIF_COMPROBANTE: codigo,
        p_COM_CODIGO: '01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  calculartotales() {
    let total = 0
    for (const iterator of this.detcif) {
      iterator.DETCIF_COSTO = this.utilitariosService.formatear(iterator.DETCIF_COSTO, this.decimalesCostoind)
      total = this.utilitariosService.sumar(total, iterator.DETCIF_COSTO)
    }
    this.enccif[this.init.tabs[this.init.tabindex].indice].ENCCIF_TOTAL = this.utilitariosService.formatear(total, this.decimalesCostoind)
  }
  eliminarDetalledetcif(item, encordnumero,centrab) {
    return this.http.post<any[]>(this.way + '/produccion/prodcosindtra/1d595a57575aef0000', {
      elementos: {
        p_ENCCIF_COMPROBANTE: item.ENCCIF_COMPROBANTE,
        p_CIN_CODIGO: item.CIN_CODIGO,
        p_encordpro_numero: encordnumero,
        p_CENTRA_CODIGO: centrab,
        p_com_codigo: item.COM_CODIGO

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  generarasiento(codigo) {
    return this.http.post<any[]>(this.way + '/produccion/prodcosindtra/83aeedab6ae4a000000000000', {
      elementos: {
        p_enccif_comprobante: codigo,
        p_com_codigo: '01',
        p_tipdia_codigo: 'CIT',
        p_origen: 'PROD',
        p_usuario: this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
